import * as React from 'react';
import styles from './index.less';
import { connect } from 'dva';
import { ConnectState, ResourceDetailPageModelState } from '@/models/connect';
import { RouteComponentProps } from 'react-router/index';
import { Dispatch } from 'redux';
import useUrlState from '@ahooksjs/use-url-state';
import {
  OnMountPageAction,
  OnUnmountPageAction,
  ChangeAction,
  OnClickCollectionAction,
  OnChangeVersionAction,
} from '@/models/resourceDetailPage';
import * as AHooks from 'ahooks';
import FComponentsLib from '@freelog/components-lib';
import img_choiceLabel from '@/assets/choice-label@2x.png';
import FTooltip from '@/components/FTooltip';
// import FDropdownMenu from '@/components/FDropdownMenu';
import FResourceProperties from '@/components/FResourceProperties';
import FResourceOptions from '@/components/FResourceOptions';
import FCoverImage from '@/components/FCoverImage';
import { Space } from 'antd';
import FGraph_Tree_Authorization_Resource from '@/components/FAntvG6/FGraph_Tree_Authorization_Resource';
import fGraphTree_Authorization_Resource from '@/components/FAntvG6/fGraphTree_Authorization_Resource';
import FGraph_Tree_Dependency_Resource from '@/components/FAntvG6/FGraph_Tree_Dependency_Resource';
import fGraphTree_Dependency_Resource from '@/components/FAntvG6/fGraphTree_Dependency_Resource';
import FExpandable from './FExpandable';
import FLoadingTip from '@/components/FLoadingTip';
import { FShare } from '@/components/FShare';
import { FI18n, FServiceAPI, FUtil } from '@freelog/tools-lib';
import FHtmlReactParser from '@/components/FHtmlReactParser';
import { history, MicroApp } from 'umi';
import { initGlobalState, MicroAppStateActions } from 'qiankun';
import FResourceStatusBadge from '@/components/FResourceStatusBadge';
import fMessage from '@/components/fMessage';
import FIcons from '@/components/FIcons';
import FCopyToClipboard from '@/components/FCopyToClipboard';
import FSimpleBar from '@/components/FSimpleBar';
// import FMicroApp_SignResourceToNode from '@/components/FMicroApp_SignResourceToNode';
// import FMicroApp_SignResourceToNode_2 from '@/components/FMicroApp_SignResourceToNode_2';
import FMicroApp_SignResourceToNode_3 from '@/components/FMicroApp_SignResourceToNode_3';
import MicroAppStateActionsMgr from '@/utils/MicroAppStateActionsMgr';
import FDropdown2 from '@/components/FDropdown2';

// const state = {
//   // 授权处理器弹窗显示
//   authProcessorShow: false,
//   // 授权方 id
//   licensorId: '',
//   licensorResourceVersion: '',
// };

// const actions: MicroAppStateActions = initGlobalState(state);

interface ResourceDetailsProps extends RouteComponentProps<{ id: string }> {
  dispatch: Dispatch;
  resourceDetailPage: ResourceDetailPageModelState;
}

function ResourceDetails({ match, dispatch, resourceDetailPage }: ResourceDetailsProps) {
  // const refContainer = React.useRef(null);
  const refButton = React.useRef(null);
  const [inViewport] = AHooks.useInViewport(refButton);
  // console.log(inViewport, 'inViewport sdifjsdlkfjlsdjflkjsdlfjsdlj');
  const [state] = useUrlState<{ version: string }>();

  const [$openSignResourceDrawer, set$openSignResourceDrawer, get$openSignResourceDrawer] =
    FUtil.Hook.useGetState<boolean>(false);

  AHooks.useMount(async () => {
    dispatch<OnMountPageAction>({
      type: 'resourceDetailPage/onMountPage',
      payload: {
        resourceID: match.params.id,
        version: state.version,
      },
    });
  });

  AHooks.useUnmount(() => {
    dispatch<OnUnmountPageAction>({
      type: 'resourceDetailPage/onUnmountPage',
    });
  });

  if (resourceDetailPage.page_State === 'loading') {
    return <FLoadingTip height={'calc(100vh - 140px)'} />;
  }

  async function signNode() {
    await FServiceAPI.User.currentUserInfo();
    const { data, ret, errCode, msg } = await FServiceAPI.Resource.info({
      resourceIdOrName: match.params.id,
    });

    if (ret !== 0 || errCode !== 0) {
      return fMessage(msg, 'error');
    }

    if (data.status !== 1) {
      return fMessage('该资源未上架，无法获取授权。', 'error');
    }

    MicroAppStateActionsMgr.setState({
      authProcessorShow: true,
      licensorId: resourceDetailPage.resource_ID,
      licensorResourceVersion: resourceDetailPage.resourceVersion_SelectedVersion,
    });
  }

  return (
    <>
      <FSimpleBar height={'calc(100vh - 70px)'}>
        <div className={styles.styles}>
          <div className={styles.content}>
            <div style={{ height: 40 }} />
            <div
              className={styles.cover}
              style={{
                backgroundImage: 'url(' + resourceDetailPage.resource_Info?.cover + ')',
              }}
            >
              <div />
              <article
                style={{
                  backgroundImage: 'url(' + resourceDetailPage.resource_Info?.cover + ')',
                }}
              />
            </div>
            <div style={{ height: 30 }} />
            <div className={styles.article}>
              <div className={styles.articleLeft}>
                <div className={styles.title}>
                  <FComponentsLib.FTitleText
                    text={
                      resourceDetailPage.resource_Info?.title ||
                      resourceDetailPage.resource_Info?.name.split('/')[1] ||
                      ''
                    }
                    type={'h1'}
                    style={{
                      whiteSpace: 'break-spaces',
                      wordBreak: 'break-all',
                    }}
                  />
                  <div style={{ height: 20 }} />
                  <div className={styles.resourceName}>
                    <FComponentsLib.FContentText
                      type={'additional2'}
                      style={{ color: '#666' }}
                      text={`${FI18n.i18nNext.t('resourcedetails_authid')}：${
                        resourceDetailPage.resource_Info.name
                      }`}
                    />

                    <div className={styles.copy}>
                      <FCopyToClipboard
                        text={resourceDetailPage.resource_Info.name}
                        title={FI18n.i18nNext.t('nodemgnt_btn_copynodeaddr_tooltip')}
                        iconStyle={{ fontSize: 14 }}
                      />
                    </div>
                  </div>
                  <div style={{ height: 20 }} />
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <div className={styles.resourceInfo}>
                      <div className={styles.resourceInfoUser}>
                        <img src={resourceDetailPage.resource_Info?.useAvatar || ''} alt={''} />
                        <FComponentsLib.FContentText
                          type={'additional2'}
                          style={{ color: '#666' }}
                          text={resourceDetailPage.resource_Info?.username || ''}
                        />
                      </div>
                      <div style={{ borderLeft: '1px solid #999', height: 14 }} />
                      <FComponentsLib.FContentText
                        type={'additional2'}
                        style={{ color: '#666' }}
                        text={resourceDetailPage.resource_Info?.type.join('/') || ''}
                      />
                    </div>

                    {resourceDetailPage.resource_Info?.isChoice && (
                      <FTooltip title={'编辑精选'} placement={'bottomLeft'}>
                        <img src={img_choiceLabel} alt={''} style={{ width: 24, height: 24 }} />
                      </FTooltip>
                    )}
                  </div>
                  {resourceDetailPage.resource_Info.about && (
                    <>
                      <div style={{ height: 25 }} />
                      <FComponentsLib.FContentText
                        text={resourceDetailPage.resource_Info.about}
                        type={'normal'}
                        style={{ wordBreak: 'break-all' }}
                      />
                    </>
                  )}

                  <div style={{ height: 20 }} />
                  <div className={styles.handle}>
                    <div
                      className={styles.handleButton}
                      onClick={() => {
                        dispatch<OnClickCollectionAction>({
                          type: 'resourceDetailPage/onClickCollection',
                        });
                      }}
                    >
                      <FIcons.FFavorite
                        style={{ fontSize: 16 }}
                        filled={resourceDetailPage.resource_IsCollected}
                      />
                      <div style={{ width: 2 }} />
                      <span>{resourceDetailPage.resource_IsCollected ? '已收藏' : '收藏'}</span>
                      <div style={{ width: 10 }} />
                      <span>({resourceDetailPage.resource_Popularity}人气)</span>
                    </div>
                    <FShare
                      type='resource'
                      title={resourceDetailPage.resource_Info.title}
                      url={window.location.href}
                      desc={resourceDetailPage.resource_Info.about}
                      cover={resourceDetailPage.resource_Info.cover}
                    >
                      <div
                        className={styles.handleButton}
                        onClick={async () => {
                          await FServiceAPI.Activity.pushMessageTask({
                            taskConfigCode: 'TS000024',
                          });
                        }}
                      >
                        <FIcons.FShare style={{ fontSize: 16 }} />
                        <div style={{ width: 2 }} />
                        <span>分享</span>
                      </div>
                    </FShare>
                  </div>
                </div>
                <div style={{ height: 5 }} />
                <div
                  className={styles.version}
                  style={{
                    display:
                      resourceDetailPage.resourceVersion_AllVersions.length > 0 ? 'block' : 'none',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <FComponentsLib.FContentText
                      text={`当前版本${resourceDetailPage.resourceVersion_SelectedVersion}`}
                      type={'highlight'}
                    />
                    {/* <FDropdownMenu
                      options={[...resourceDetailPage.resourceVersion_AllVersions]
                        .reverse()
                        .map((v) => ({ value: v }))}
                      onChange={(value) => {
                        dispatch<OnChangeVersionAction>({
                          type: 'resourceDetailPage/onChangeVersion',
                          payload: {
                            version: value,
                          },
                        });
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 5,
                          color: '#2784FF',
                          cursor: 'pointer',
                        }}
                      >
                        <FIcons.FSwap style={{ fontSize: 12 }} />
                        <span style={{ fontSize: 12 }}>切换版本</span>
                      </div>
                    </FDropdownMenu> */}

                    <FDropdown2
                      autoArrow={false}
                      // getPopupContainer={() => ref_Root.current as HTMLElement}
                      menu={{
                        selectedKeys: [resourceDetailPage.resourceVersion_SelectedVersion],
                        items: [...resourceDetailPage.resourceVersion_AllVersions]
                          .reverse()
                          .map((v) => {
                            return {
                              key: v,
                              label: v,
                            };
                          }),
                        onClick: (value) => {
                          dispatch<OnChangeVersionAction>({
                            type: 'resourceDetailPage/onChangeVersion',
                            payload: {
                              version: value.key,
                            },
                          });
                        },
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 5,
                          color: '#2784FF',
                          cursor: 'pointer',
                        }}
                      >
                        <FIcons.FSwap style={{ fontSize: 12 }} />
                        <span style={{ fontSize: 12 }}>切换版本</span>
                      </div>
                    </FDropdown2>
                  </div>
                  <div style={{ height: 5 }} />
                  <FComponentsLib.FContentText
                    text={`发布时间 ${resourceDetailPage.resourceVersion_Info.releaseTime}`}
                    type={'additional2'}
                  />
                  <div style={{ height: 20 }} />
                  {/*<div style={{ height: 144 }} />*/}
                  <FExpandable dep={resourceDetailPage.resourceVersion_SelectedVersion}>
                    {resourceDetailPage.resourceVersion_Info.description === '' ||
                    resourceDetailPage.resourceVersion_Info.description === '<p></p>' ? (
                      <FComponentsLib.FContentText
                        text={FI18n.i18nNext.t('description_empty')}
                        type={'additional2'}
                      />
                    ) : (
                      <FHtmlReactParser str={resourceDetailPage.resourceVersion_Info.description} />
                    )}
                  </FExpandable>
                </div>
                {(resourceDetailPage.resourceVersion_Info.rawProperties.length > 0 ||
                  resourceDetailPage.resourceVersion_Info.baseProperties.length > 0) && (
                  <>
                    <div style={{ height: 5 }} />
                    <div className={styles.property}>
                      <FComponentsLib.FContentText text={'基础属性'} type={'highlight'} />
                      <div style={{ height: 20 }} />
                      <FResourceProperties
                        // keysSort={resourceDetailPage.propertyKeysSort}
                        immutableData={resourceDetailPage.resourceVersion_Info.rawProperties}
                        onlyEditValueData={[]}
                        alterableData={resourceDetailPage.resourceVersion_Info.baseProperties}
                        keyMaxWidth={84}
                        valueMaxWidth={190}
                      />
                    </div>
                  </>
                )}

                {resourceDetailPage.resourceVersion_Info.customOptions.length > 0 && (
                  <>
                    <div style={{ height: 5 }} />
                    <div className={styles.configuration}>
                      <FComponentsLib.FContentText text={'可选配置'} type={'highlight'} />
                      <div style={{ height: 20 }} />
                      <FResourceOptions
                        theme={'dark'}
                        dataSource={resourceDetailPage.resourceVersion_Info.customOptions}
                      />
                    </div>
                  </>
                )}
              </div>

              <div className={styles.articleRight}>
                <div className={styles.authorize}>
                  <FComponentsLib.FContentText text={'资源授权方案'} type={'highlight'} />
                  <div style={{ height: 20 }} />
                  <div ref={refButton}>
                    <FComponentsLib.FRectBtn
                      style={{ height: 50, width: 400 }}
                      disabled={resourceDetailPage.resource_Info.error !== ''}
                      onClick={() => {
                        signNode();
                      }}
                    >
                      签约至节点
                    </FComponentsLib.FRectBtn>
                  </div>
                  <div style={{ height: 20 }} />

                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <FComponentsLib.FContentText
                      text={'当前资源'}
                      type={'additional2'}
                      style={{ flexShrink: 0 }}
                    />
                    <div
                      style={{
                        width: '100%',
                        flexShrink: 1,
                        borderTop: '1px solid #E5E7EB',
                      }}
                    />
                  </div>
                  <div style={{ height: 15 }} />
                  <div className={styles.authorizeResource}>
                    <div
                      style={{
                        width: 'fit-content',
                        height: 'fit-content',
                        position: 'relative',
                      }}
                    >
                      <FCoverImage
                        src={resourceDetailPage.resource_Info.cover || ''}
                        width={104}
                        style={{ borderRadius: 4 }}
                      />
                      <div className={styles.Status}>
                        {resourceDetailPage.resource_Info.error !== '' && (
                          <FResourceStatusBadge status={resourceDetailPage.resource_Info.error} />
                        )}

                        {resourceDetailPage.resource_Info.isChoice && (
                          <FTooltip title={'编辑精选'} placement={'bottomLeft'}>
                            <img src={img_choiceLabel} alt={''} style={{ width: 24, height: 24 }} />
                          </FTooltip>
                        )}
                      </div>
                    </div>
                    <div className={styles.authorizeResourceRight}>
                      <FComponentsLib.FContentText
                        text={
                          resourceDetailPage.resource_Info.title ||
                          resourceDetailPage.resource_Info.name.split('/')[0]
                        }
                        type={'highlight'}
                        style={{ wordBreak: 'break-all' }}
                      />
                      <div style={{ height: 5 }} />
                      <Space size={10}>
                        <div className={styles.resourceInfoUser}>
                          <img
                            style={{ width: 20, height: 20 }}
                            src={resourceDetailPage.resource_Info.useAvatar}
                            alt={''}
                          />
                          {resourceDetailPage.resource_Info.isChoice && (
                            <FComponentsLib.FContentText
                              type={'additional2'}
                              style={{ color: '#666' }}
                              text={resourceDetailPage.resource_Info.username}
                            />
                          )}
                        </div>
                        <div style={{ borderLeft: '1px solid #999', height: 14 }} />
                        <FComponentsLib.FContentText
                          type={'additional2'}
                          style={{ color: '#666' }}
                          text={resourceDetailPage.resource_Info.type.join('/')}
                        />
                      </Space>
                      <div style={{ height: 5 }} />
                      {resourceDetailPage.resource_Info.error !== '' && (
                        <div
                          style={{
                            fontWeight: 600,
                            fontSize: 12,
                            color: '#E9A923',
                            lineHeight: '18px',
                          }}
                        >
                          无法获取授权
                        </div>
                      )}

                      {resourceDetailPage.resource_Info.error === '' &&
                        resourceDetailPage.resource_Info.warning === 'authException' && (
                          <>
                            <div
                              style={{
                                fontWeight: 600,
                                fontSize: 12,
                                color: '#E9A923',
                                lineHeight: '18px',
                              }}
                            >
                              {FI18n.i18nNext.t('alarm_resource_authorization_abnormal')}
                            </div>
                            <div style={{ height: 5 }} />
                          </>
                        )}

                      {resourceDetailPage.resource_Info.error === '' &&
                        resourceDetailPage.resource_Info.warning === 'ownerFreeze' && (
                          <>
                            <div
                              style={{
                                fontWeight: 600,
                                fontSize: 12,
                                color: '#E9A923',
                                lineHeight: '18px',
                              }}
                            >
                              {FI18n.i18nNext.t('alert_auth_useraccountdisable_resouce')}
                            </div>
                            <div style={{ height: 5 }} />
                          </>
                        )}

                      {resourceDetailPage.resource_Info.error === '' && (
                        <div className={styles.policies}>
                          {resourceDetailPage.resource_Info?.policyTitles.map((pt, ptIndex) => {
                            return (
                              <label key={ptIndex}>
                                <FIcons.FPolicy style={{ fontSize: 14 }} />
                                <span>{pt}</span>
                              </label>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </div>

                  {resourceDetailPage.resource_Info.error === '' &&
                    resourceDetailPage.resource_baseUpcastResources.length > 0 && (
                      <>
                        <div style={{ height: 15 }} />
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10,
                          }}
                        >
                          <FComponentsLib.FContentText
                            text={'当前资源包含以下基础上抛'}
                            type={'additional2'}
                            style={{ flexShrink: 0 }}
                          />
                          <div
                            style={{
                              width: '100%',
                              flexShrink: 1,
                              borderTop: '1px solid #E5E7EB',
                            }}
                          />
                        </div>

                        <div style={{ height: 15 }} />
                      </>
                    )}

                  {resourceDetailPage.resource_Info.error === '' &&
                    resourceDetailPage.resource_baseUpcastResources.map((rbur, rburIndex) => {
                      if (
                        !resourceDetailPage.resource_baseUpcastResources_showMore &&
                        rburIndex > 2
                      ) {
                        return null;
                      }
                      return (
                        <React.Fragment key={rbur.id}>
                          {rburIndex !== 0 && <div style={{ height: 15 }} />}
                          <div className={styles.authorizeResource}>
                            <div
                              style={{
                                width: 'fit-content',
                                height: 'fit-content',
                                position: 'relative',
                              }}
                            >
                              <FCoverImage
                                src={rbur.cover || ''}
                                width={104}
                                style={{ borderRadius: 4 }}
                              />
                              <div className={styles.Status}>
                                {rbur.error !== '' && (
                                  <FResourceStatusBadge
                                    style={{ transform: 's' }}
                                    status={rbur.error}
                                  />
                                )}

                                {rbur.isChoice && (
                                  <FTooltip title={'编辑精选'} placement={'bottomLeft'}>
                                    <img
                                      src={img_choiceLabel}
                                      alt={''}
                                      style={{ width: 24, height: 24 }}
                                    />
                                  </FTooltip>
                                )}
                              </div>
                            </div>
                            <div className={styles.authorizeResourceRight}>
                              <FComponentsLib.FContentText
                                text={rbur.title || rbur.name.split('/')[0]}
                                type={'highlight'}
                              />
                              <div style={{ height: 5 }} />
                              <Space size={10}>
                                <div className={styles.resourceInfoUser}>
                                  <img
                                    style={{ width: 20, height: 20 }}
                                    src={rbur.useAvatar || ''}
                                    alt={''}
                                  />
                                  <FComponentsLib.FContentText
                                    type={'additional2'}
                                    style={{ color: '#666' }}
                                    text={rbur.username}
                                  />
                                </div>
                                <div
                                  style={{
                                    borderLeft: '1px solid #999',
                                    height: 14,
                                  }}
                                />
                                <FComponentsLib.FContentText
                                  type={'additional2'}
                                  style={{ color: '#666' }}
                                  text={rbur.type.join('/')}
                                />
                              </Space>
                              <div style={{ height: 5 }} />
                              {rbur.error !== '' && (
                                <div
                                  style={{
                                    fontWeight: 600,
                                    fontSize: 12,
                                    color: '#E9A923',
                                    lineHeight: '18px',
                                  }}
                                >
                                  无法获取授权
                                </div>
                              )}

                              {rbur.error === '' && rbur.warning === 'authException' && (
                                <>
                                  <div
                                    style={{
                                      fontWeight: 600,
                                      fontSize: 12,
                                      color: '#E9A923',
                                      lineHeight: '18px',
                                    }}
                                  >
                                    {FI18n.i18nNext.t('alarm_resource_authorization_abnormal')}
                                  </div>
                                  <div style={{ height: 5 }} />
                                </>
                              )}

                              {rbur.error === '' && rbur.warning === 'ownerFreeze' && (
                                <>
                                  <div
                                    style={{
                                      fontWeight: 600,
                                      fontSize: 12,
                                      color: '#E9A923',
                                      lineHeight: '18px',
                                    }}
                                  >
                                    {FI18n.i18nNext.t('alert_auth_useraccountdisable_resouce')}
                                  </div>
                                  <div style={{ height: 5 }} />
                                </>
                              )}

                              {rbur.error === '' && (
                                <div className={styles.policies}>
                                  {rbur.policyTitles.map((p, pi) => {
                                    return (
                                      <label key={pi}>
                                        <FIcons.FPolicy style={{ fontSize: 14 }} />
                                        <span>{p}</span>
                                      </label>
                                    );
                                  })}
                                </div>
                              )}
                            </div>
                          </div>
                        </React.Fragment>
                      );
                    })}

                  {resourceDetailPage.resource_baseUpcastResources.length > 3 &&
                    !resourceDetailPage.resource_baseUpcastResources_showMore && (
                      <>
                        <div style={{ height: 10 }} />
                        <FComponentsLib.FTextBtn
                          style={{ fontSize: 12 }}
                          type={'primary'}
                          onClick={() => {
                            dispatch<ChangeAction>({
                              type: 'resourceDetailPage/change',
                              payload: {
                                resource_baseUpcastResources_showMore: true,
                              },
                            });
                          }}
                        >
                          展开全部（
                          {resourceDetailPage.resource_baseUpcastResources.length}）
                        </FComponentsLib.FTextBtn>
                      </>
                    )}

                  {resourceDetailPage.resource_baseUpcastResources.length > 3 &&
                    resourceDetailPage.resource_baseUpcastResources_showMore && (
                      <>
                        <div style={{ height: 10 }} />
                        <FComponentsLib.FTextBtn
                          style={{ fontSize: 12 }}
                          type={'primary'}
                          onClick={() => {
                            dispatch<ChangeAction>({
                              type: 'resourceDetailPage/change',
                              payload: {
                                resource_baseUpcastResources_showMore: false,
                              },
                            });
                          }}
                        >
                          收起
                        </FComponentsLib.FTextBtn>
                      </>
                    )}
                </div>

                {resourceDetailPage.resource_Info.tags.length > 0 && (
                  <>
                    <div style={{ height: 5 }} />
                    <div className={styles.label}>
                      <FComponentsLib.FContentText text={'标签'} type={'highlight'} />
                      <div style={{ height: 20 }} />
                      <div className={styles.resourceLabels}>
                        {resourceDetailPage.resource_Info.tags.map((label, labelIndex) => {
                          return <label key={labelIndex}>{label}</label>;
                        })}
                      </div>
                    </div>
                  </>
                )}
                {resourceDetailPage.resourceVersion_authorizationGraphShow &&
                  resourceDetailPage.resourceVersion_AllVersions.length > 0 && (
                    <div>
                      <div style={{ height: 5 }} />
                      <div className={styles.relationship}>
                        <FComponentsLib.FContentText text={'授权链视图'} type={'highlight'} />
                        <div style={{ height: 20 }} />
                        <div className={styles.ViewportCard}>
                          <div className={styles.Viewport}>
                            <FGraph_Tree_Authorization_Resource
                              resourceID={resourceDetailPage.resource_ID}
                              version={resourceDetailPage.resourceVersion_SelectedVersion}
                              width={400}
                              height={120}
                              fit={true}
                              onMount={({ hasData }) => {
                                dispatch<ChangeAction>({
                                  type: 'resourceDetailPage/change',
                                  payload: {
                                    resourceVersion_authorizationGraphShow: hasData,
                                  },
                                });
                              }}
                            />
                          </div>

                          <div className={styles.ViewportCardBottom}>
                            <FComponentsLib.FContentText text={'授权树'} type={'normal'} />
                          </div>

                          <div className={styles.ViewportCardMask}>
                            <a
                              onClick={async () => {
                                await fGraphTree_Authorization_Resource({
                                  resourceID: resourceDetailPage.resource_ID,
                                  version: resourceDetailPage.resourceVersion_SelectedVersion,
                                });
                              }}
                            >
                              点击全屏查看
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                {resourceDetailPage.resourceVersion_dependencyGraphShow &&
                  resourceDetailPage.resourceVersion_AllVersions.length > 0 && (
                    <div>
                      <div style={{ height: 5 }} />
                      <div className={styles.authorization}>
                        <FComponentsLib.FContentText text={'依赖链视图'} type={'highlight'} />
                        <div style={{ height: 20 }} />

                        <div className={styles.ViewportCard}>
                          <div className={styles.Viewport}>
                            <FGraph_Tree_Dependency_Resource
                              resourceID={resourceDetailPage.resource_ID}
                              version={resourceDetailPage.resourceVersion_SelectedVersion}
                              width={400}
                              height={120}
                              fit={true}
                              onMount={({ hasData }) => {
                                dispatch<ChangeAction>({
                                  type: 'resourceDetailPage/change',
                                  payload: {
                                    resourceVersion_dependencyGraphShow: hasData,
                                  },
                                });
                              }}
                            />
                          </div>

                          <div className={styles.ViewportCardBottom}>
                            <FComponentsLib.FContentText text={'依赖树'} type={'normal'} />
                          </div>

                          <div className={styles.ViewportCardMask}>
                            <a
                              onClick={async () => {
                                await fGraphTree_Dependency_Resource({
                                  resourceID: resourceDetailPage.resource_ID,
                                  version: resourceDetailPage.resourceVersion_SelectedVersion,
                                });
                              }}
                            >
                              点击全屏查看
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
              </div>
            </div>
            <div style={{ height: 140 }} />
          </div>

          {!inViewport && (
            <div className={styles.fixFooter}>
              <div>
                <FComponentsLib.FRectBtn
                  style={{ height: 50, width: 440 }}
                  disabled={resourceDetailPage.resource_Info.error !== ''}
                  onClick={() => {
                    signNode();
                  }}
                >
                  签约至节点
                </FComponentsLib.FRectBtn>
              </div>
            </div>
          )}
        </div>
      </FSimpleBar>
      {resourceDetailPage.user_Logged && (
        <FMicroApp_SignResourceToNode_3
          onSuccess={({ exhibtID, nodeID }) => {
            history.push(
              FUtil.LinkTo.exhibitManagement({ exhibitID: exhibtID }) + '?openAuthDrawer=true',
            );
          }}
        />
      )}
    </>
  );
}

export default connect(({ resourceDetailPage }: ConnectState) => ({
  resourceDetailPage,
}))(ResourceDetails);
